import { z } from 'zod';
import { defineForm } from '../registry.js';
import { CONFIRMERS, evidenceFields, idString, longtext } from './common.js';

// 第3表（週間サービス計画表）。旧: WeeklyVersionRecord（cells / dailyActivities / nonWeeklyServices）。
// 上限は旧 API（cells 200、文章 5000）。変更連鎖の提案側はもっと厳しかった（cells 100、文章 1500、時刻 00:00〜23:59、開始<終了、重なりなし）。
// 開始<終了・重なりは旧 API でも検査していないので、ここでも本文の形としては見ない。

export const WEEKLY_DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;
export type WeeklyDayOfWeek = (typeof WEEKLY_DAYS)[number];
export const WEEKLY_DAY_LABELS: Record<WeeklyDayOfWeek, string> = {
  mon: '月',
  tue: '火',
  wed: '水',
  thu: '木',
  fri: '金',
  sat: '土',
  sun: '日',
};

const hhmm = z.string().regex(/^\d{2}:\d{2}$/, 'HH:MM で入力してください');

export const weeklyCellSchema = z
  .object({
    dayOfWeek: z.enum(WEEKLY_DAYS).meta({ optionLabels: WEEKLY_DAY_LABELS }).describe('曜日'),
    startTime: hhmm.describe('開始時刻'),
    endTime: hhmm.describe('終了時刻'),
    serviceId: idString.describe('サービスID（第2表）'),
    // 旧 API は必須。Python のエージェントは省略時 true にしていた
    isInsurance: z.boolean().describe('保険給付内'),
  })
  .strict();

export const careplan3Schema = z
  .object({
    cells: z.array(weeklyCellSchema).max(200).describe('週間の予定'),
    dailyActivities: longtext('主な日常生活上の活動', 5000),
    nonWeeklyServices: longtext('週単位以外のサービス', 5000),
    ...evidenceFields,
  })
  .strict();
export type Careplan3Body = z.infer<typeof careplan3Schema>;

export const careplan3Form = defineForm({
  app: 'caremanager',
  docType: 'careplan3',
  name: '週間サービス計画表（第3表）',
  version: 1,
  schema: careplan3Schema,
  confirmers: CONFIRMERS,
  description: '曜日・時間帯ごとのサービス配置。サービスID は確定済みの第2表のサービスを指す',
});
